<template>
    <button v-if="isVisible" @click="scrollToTop"  class="back-to-top">
      ↑ Back to Top
    </button>
    <div @click="scrollToTop" class="progress-wrap">
       <svg class="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
      </svg>
  </div>
  </template>
  
  <script>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  export default {
    name: "BackToTop",
    setup() {
      const isVisible = ref(false);
  
      const checkScroll = () => {
        isVisible.value = window.scrollY > 300;
      };
  
      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };
  
      onMounted(() => {
        window.addEventListener('scroll', checkScroll);
      });
  
      onUnmounted(() => {
        window.removeEventListener('scroll', checkScroll);
      });
  
      return { isVisible, scrollToTop };
    },
  };
  </script>
  
  <style scoped>
  .back-to-top {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #35495e;
    color: white;
    border: none;
    padding: 10px;
    cursor: pointer;
  }
  </style>
  